import RcTooltip from 'rc-tooltip';
import React from 'react';
import '../../styles/Tooltip.scss';

export const Tooltip = ({ content, children }) => {
  return (
    <RcTooltip overlayClassName={'rc-tooltip-bg-white'} placement={'bottom'} overlay={content}>
      {children}
    </RcTooltip>
  );
};
